import { colors } from '@/system/config/_theme';

const settings = function(store){
	return store.getters.settings
}

export { settings, colors };
